import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { TicketCategoriesComponent } from '../pages/cms/ticket-categories/ticket-categories.component';
import { CmsTicketCategoryService } from '../services/cms-ticket-category/cms-ticket-category.service';

@Injectable({
  providedIn: 'root',
})
export class TicketCategoryFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<TicketCategoriesComponent>
{
  private readonly cmsTicketCategoryService: CmsTicketCategoryService = inject(
    CmsTicketCategoryService
  );

  canDeactivate(
    component: TicketCategoriesComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      this.cmsTicketCategoryService.isDirty(),
      nextState.url,
      () => component.resetFormChanges(),
      () => component.save()
    );
  }
}
